var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h2',[_vm._v("Welcome to Our Site Index")]),_c('keep-alive',[_c('HomeContent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }